import { selecetedShopIdActionTypes } from './selected-shop-id-reducer';

export type HasDefaultDurationBeenSetReducerState = boolean;

export const hasDefaultDurationBeenSetReducerInitialState: HasDefaultDurationBeenSetReducerState =
  false;

export enum hasDefaultDurationBeenSetActionTypes {
  HAS_DEFAULT_DURATION_BEEN_SET = 'HAS_DEFAULT_DURATION_BEEN_SET',
}

export interface HasDefaultDurationBeenSetReducerAction {
  type: hasDefaultDurationBeenSetActionTypes | selecetedShopIdActionTypes;
  payload: boolean;
}

const hasDefaultDurationBeenSetReducer = (
  state: HasDefaultDurationBeenSetReducerState,
  action: HasDefaultDurationBeenSetReducerAction
): HasDefaultDurationBeenSetReducerState => {
  switch (action.type) {
    case hasDefaultDurationBeenSetActionTypes.HAS_DEFAULT_DURATION_BEEN_SET: {
      return action.payload;
    }
    case selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE: {
      return false;
    }
    default:
      return state;
  }
};

export default hasDefaultDurationBeenSetReducer;
